import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { FaTrash } from 'react-icons/fa'
import { IoIosAddCircleOutline } from 'react-icons/io'

import {
  Input,
  TextArea,
  NumberInput,
  SearchSelect,
  CustomSearchSelect,
} from '../../../../../input'
import { ap_status, credit_term } from '../../../../constants'
import { CustomDatePicker } from '../../../../../datepicker'
import { FONTS } from '../../../../../../constants'
import { formatNumber } from '../../../../../../function/math'

export const PartialDetail = ({ detailState, handleInput }) => {
  const {
    partials = [],
    remark,
  } = detailState

  return (
    <Root>
      <HeaderText>Partial Detail</HeaderText>
      <Col>
        {partials.map((partial, key) => {
          const _credit_term = credit_term.find(c => c.value === partial.credit_term)
          const _status = ap_status.find(s => s.value === partial.status)

          return (
            <PartialWrapper key={ key }>
              <Col>
                <Title>Period</Title>
                <AlignCenterWrapper>
                  <Text>{ partial.period_no }</Text>
                </AlignCenterWrapper>
              </Col>
              <Col>
                <Title>Description</Title>
                <Input
                  value={ partial.description }
                  placeholder='Enter Description'
                  onChange={ e => handleInput(e.target.value, 'description', key) }
                />
              </Col>
              <Col>
                <Title>Cost Amount</Title>
                <NumberInput
                  suffix='฿'
                  allowEmptyFormatting={ true }
                  thousandSeparator={ true }
                  decimalScale={ 2 }
                  fixedDecimalScale={ true }
                  value={ partial.cost }
                  onChange={ e => handleInput(formatNumber(e.target.value), 'cost', key) }
                />
              </Col>
              <Col>
                <Title>Delivery Date</Title>
                <CustomDatePicker
                  dateFormat='DD/MM/YYYY'
                  selected={ partial.delivery_date ? moment(partial.delivery_date) : null }
                  onChange={ e => handleInput(e, 'delivery_date', key) }
                />
              </Col>
              <Col>
                <Title>Credit Term</Title>
                <SearchSelect
                  value={ _credit_term }
                  options={ credit_term }
                  placeholder='Select Credit Term'
                  onChange={ e => handleInput(e.value, 'credit_term', key) }
                />
              </Col>
              <Col>
                <Title>Status</Title>
                <CustomSearchSelect
                  value={ _status }
                  options={ ap_status }
                  placeholder='Select Status'
                  onChange={ e => handleInput(e.value, 'status', key) }
                />
              </Col>
              <Col justify='center' align='center'>
                <Trash onClick={ () => handleInput(key, 'remove') } />
              </Col>
            </PartialWrapper>
          )
        })}
      </Col>
      <AddWrapper onClick={ () => handleInput('', 'add') }>
        <IoIosAddCircleOutline style={ { color: '#2D9CDB', fontSize: 16 } } />
        <AddText>&nbsp;Add Partial Payment</AddText>
      </AddWrapper>
      <FlexRow>
        <NoBorderCol flex={ 1 }>
          <EntryTitle>Remark</EntryTitle>
          <TextArea
            placeholder='Enter Remark'
            value={ remark }
            onChange={ e => handleInput(e.target.value, 'remark') }
          />
        </NoBorderCol>
      </FlexRow>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
  margin-bottom: 16px;
`

const Row = styled.div`
  display: flex;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${p => (p.justify ? p.justify : 'flex-start')};
  align-items: ${p => (p.align ? p.align : 'flex-start')};
`

const FlexRow = styled(Row)`
  margin-bottom: 16px;
  ${p => p.flex && `flex: ${p.flex}`}
`

const FlexCol = styled(Col)`
  margin: ${p => p.margin};
  ${p => p.flex && `flex: ${p.flex}`}
`

const Title = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`

const AddWrapper = styled.div`
  display: flex;
  height: 30px;
  width: fit-content;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
`

const AddText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: #2D9CDB;
`

const AlignCenterWrapper = styled(Row)`
  height: 100%;
  align-items: center;
`

const PartialWrapper = styled.div`
  height: 75px;
  width: 100%;
  background: #F9F9F9;
  border: 1px solid #F1F1F1;
  border-radius: 4px;
  padding: 12px;
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 2fr 2fr 2fr 1fr;
  grid-gap: 8px;
  margin-bottom: 6px;
`

const Trash = styled(FaTrash)`
  font-size: 16px;
  color: #C4C4C4;
  cursor: pointer;

  :hover {
    color: #D44B49;
  }
`

const NoBorderCol = styled(FlexCol)`
  background: transparent;
  border: none;
  padding: 0;
`

const EntryTitle = styled(Title)`
  color: #333333;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/ap-paying/edit-ap-paying/partial-detail/index.js